export default __webpack_public_path__ + "static/media/125.f1f63b71.jpg";